import React from 'react';

function YouTubeIcon(props: React.ComponentProps<'svg'>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            {...props}>
            <path d="M21.5828 7.2007C21.4696 6.77493 21.2466 6.38636 20.9359 6.07397C20.6253 5.76158 20.238 5.53633 19.8129 5.42081C18.2496 5 12 5 12 5C12 5 5.7462 5 4.18629 5.42081C3.76135 5.53654 3.37427 5.76187 3.06379 6.07424C2.75332 6.38661 2.53036 6.77506 2.41723 7.2007C2.12922 8.7993 1.98974 10.4211 2.00059 12.0454C1.98974 13.6697 2.12922 15.2915 2.41723 16.8901C2.53036 17.3159 2.75342 17.7045 3.06406 18.0169C3.37469 18.3293 3.76199 18.5545 4.18713 18.67C5.7462 19.0867 12 19.0867 12 19.0867C12 19.0867 18.2538 19.0867 19.8137 18.67C20.2387 18.5545 20.6259 18.3292 20.9364 18.0168C21.2469 17.7044 21.4698 17.3159 21.5828 16.8901C21.8705 15.2915 22.0099 13.6697 21.9994 12.0454C22.0103 10.4211 21.8708 8.7993 21.5828 7.2007ZM9.95429 15.0186V9.07226L15.1815 12.0454L9.95429 15.0186Z"/>
        </svg>
    );
}

export default YouTubeIcon;